<template>
    <div class="wf-field">
        <label class="wf-label">
            {{ label }} <span v-if="isRequired" class="wf-required">*</span>
        </label>
        <p v-if="instruction" class="wf-instruction" v-html="instruction"></p>
        <label class="wf-checkbox-item" :class="{ 'is-selected': value }">
            <input
                type="checkbox"
                :checked="!!value"
                @change="emitValue($event.target.checked ? 1 : null)"
            />
            <span class="wf-checkbox-label">{{ $t('wizard.gdpr_accept') }}</span>
        </label>
        <p v-if="help" class="wf-help">{{ help }}</p>
    </div>
</template>

<script>
import FieldMixin from './FieldMixin'

export default {
    name: 'GdprField',
    mixins: [FieldMixin]
}
</script>
